import { render, staticRenderFns } from "./PostError.vue?vue&type=template&id=21c7dacb&"
import script from "./PostError.vue?vue&type=script&lang=js&"
export * from "./PostError.vue?vue&type=script&lang=js&"
import style0 from "./PostError.vue?vue&type=style&index=0&id=21c7dacb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports